exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-green[data-v-5267b57e] {\n    background-color: #00FF00;\n}\n.bg-red[data-v-5267b57e] {\n    background-color: #FF0000;\n}\n", ""]);

// exports
